import { render, staticRenderFns } from "./noLearningStudentDetail.vue?vue&type=template&id=3b49febe&"
import script from "./noLearningStudentDetail.vue?vue&type=script&lang=js&"
export * from "./noLearningStudentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports